export default [
  {
    "x": 66.1282,
    "y": 85.4608,
    "angle": -0.8470091730232169,
    "lengthA": 9.65387917452653,
    "lengthB": 6.718131407611044
  },
  {
    "x": 47.0922,
    "y": 57.3288,
    "angle": -0.3012323781338003,
    "lengthA": 9.09165650853552,
    "lengthB": 9.09165650853552
  },
  {
    "x": 40.8102,
    "y": 73.4301705,
    "angle": -0.4746932883274732,
    "lengthA": 1.5223503904741438,
    "lengthB": 1.5223503904741373
  },
  {
    "x": 30.3392,
    "y": 69.1678,
    "angle": -0.5508982495433123,
    "lengthA": 9.472075842468708,
    "lengthB": 9.472075842468715
  },
  {
    "x": 24.8682,
    "y": 83.8358,
    "angle": -0.32133997920706897,
    "lengthA": 2.3894893645999127,
    "lengthB": 2.389489364599916
  },
  {
    "x": 11.7304688,
    "y": 82.2188032,
    "angle": -0.7001164840356893,
    "lengthA": 8.629977081912886,
    "lengthB": 8.62997699778851
  },
  {
    "x": 9.3072,
    "y": 97.0848,
    "angle": -1.1852965187803157,
    "lengthA": 7.7626324656924774,
    "lengthB": 7.762632851377606
  },
  {
    "x": 1.0002,
    "y": 108.6608,
    "angle": -1.7068700583270326,
    "lengthA": 7.895882595004485,
    "lengthB": 7.755006359270246
  },
  {
    "x": 20.757059,
    "y": 186.917793,
    "angle": -2.194453622616168,
    "lengthA": 15.456281983645743,
    "lengthB": 11.250242923431491
  },
  {
    "x": 77.6172,
    "y": 191.5318,
    "angle": 2.55421798333128,
    "lengthA": 13.80228431357971,
    "lengthB": 17.64106950086524
  },
  {
    "x": 99.0295338,
    "y": 144.97232,
    "angle": 2.3624065268376793,
    "lengthA": 22.334808252766408,
    "lengthB": 8.359262424969321
  },
  {
    "x": 102.1872,
    "y": 126.299768,
    "angle": 0.9945602834517246,
    "lengthA": 8.313816611134614,
    "lengthB": 37.31472911320553
  },
  {
    "x": 84.0772009,
    "y": 46.6121452,
    "angle": 1.3474034188100796,
    "lengthA": 12.82552329104965,
    "lengthB": 3.8704747970246216
  },
  {
    "x": 102.992156,
    "y": 46.6121452,
    "angle": 3.141592653589793,
    "lengthA": 9.647708999999992,
    "lengthB": 9.343106000000006
  },
  {
    "x": 113.2022,
    "y": 13.0158,
    "angle": 1.2802746095510837,
    "lengthA": 6.276092525665791,
    "lengthB": 5.587485602487365
  },
  {
    "x": 73.6411225,
    "y": 2.02378123,
    "angle": -0.11537272330519156,
    "lengthA": 24.55045815811299,
    "lengthB": 20.970672452522575
  },
  {
    "x": 5.6902,
    "y": 13.0158,
    "angle": -1.5707963267948966,
    "lengthA": 21.155261969999998,
    "lengthB": 8.1834912
  },
  {
    "x": 16.7052,
    "y": 43.9938,
    "angle": 3.141592653589793,
    "lengthA": 13.69877918,
    "lengthB": 10.430178699999999
  },
  {
    "x": 68.0041442,
    "y": 55.5349841,
    "angle": -2.580007245887949,
    "lengthA": 20.565043098319233,
    "lengthB": 4.085148261660604
  }
]